const GraphQLForm = require('app/graphql/Form');

class RangeAndDeliveryDayForm extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'CopyRangeAndDeliveryDayRestaurant',
            'restaurant': null,
            'restaurants': [],
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.restaurant = this.settings.restaurant;
        this.restaurants = this.settings.restaurants;

        this.buildForm();

        super.initialize();
    }

    getRestaurant(){
        return this.restaurant;
    }

    getForm(){
        return this.$form;
    }

    buildForm(){

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(window.translate('app.restaurant.show.tabs.copy.submit.label'));

        this.$form = $('<form/>')
        .addClass('restaurant-info-form')
        .addClass('white-box')
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .append(this.$btnSubmit)
        );

        return this.$form;
    }

    buildInputs(){ 
        var self = this;

        let $box = $('<div/>');

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.restaurant.show.tabs.copy.rangeAndDeliveryDayForm.label'))
        .appendTo($box);


        //FIELD target
        let $targetLabel = $('<label/>')
        .attr('for','target')
        .append(window.translate('app.restaurant.show.tabs.copy.rangeAndDeliveryDayForm.target.label'));
        let $targetDescription = $('<div/>')
        .append(
            $('<small/>')
            .addClass('text-danger')
            .append(window.translate('app.restaurant.show.tabs.copy.rangeAndDeliveryDayForm.target.warning'))
        );

        this.$targetSelect = $('<select/>')
        .attr('name','target')
        .attr('required','required')
        .addClass('form-control')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );

        for(var i in this.restaurants){
            let restaurantItem = this.restaurants[i];

            let value = restaurantItem.node.id;
            let label = restaurantItem.node.name;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            this.$targetSelect.append($option);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($targetLabel)
            .append(this.$targetSelect)
            .append($targetDescription)
        );

        //FIELD selectSuppliers
        let $selectSuppliersLabel = $('<label/>')
        .attr('for','selectSuppliers')
        .append(window.translate('app.restaurant.show.tabs.copy.rangeAndDeliveryDayForm.selectSuppliers.label'));

        this.$selectSuppliersCheckbox = $('<input/>')
        .attr('type','checkbox')
        .attr('id','selectSuppliers')
        .attr('name','selectSuppliers')
        .attr('required','required')
        .val('1')
        .on('change',function(){
            self.onChangeOptions($(this));
        });

        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append(this.$selectSuppliersCheckbox)
            .append(' ')
            .append($selectSuppliersLabel)
        );

        //FIELD selectSupplierRanges
        let $selectSupplierRangesLabel = $('<label/>')
        .attr('for','selectSupplierRanges')
        .append(window.translate('app.restaurant.show.tabs.copy.rangeAndDeliveryDayForm.selectSupplierRanges.label'));

        this.$selectSupplierRangesCheckbox = $('<input/>')
        .attr('type','checkbox')
        .attr('id','selectSupplierRanges')
        .attr('name','selectSupplierRanges')
        .val('1')
        .on('change',function(){
            self.onChangeOptions($(this));
        });

        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append(this.$selectSupplierRangesCheckbox)
            .append(' ')
            .append($selectSupplierRangesLabel)
        );

        //FIELD selectDeliveryDays
        let $selectDeliveryDaysLabel = $('<label/>')
        .attr('for','selectDeliveryDays')
        .append(window.translate('app.restaurant.show.tabs.copy.rangeAndDeliveryDayForm.selectDeliveryDays.label'));

        this.$selectDeliveryDaysCheckbox = $('<input/>')
        .attr('type','checkbox')
        .attr('id','selectDeliveryDays')
        .attr('name','selectDeliveryDays')
        .val('1')
        .on('change',function(){
            self.onChangeOptions($(this));
        });

        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append(this.$selectDeliveryDaysCheckbox)
            .append(' ')
            .append($selectDeliveryDaysLabel)
        );


        return $box;
    }

    onChangeOptions($item){
        console.log("on change",$item);
        let suppliersChecked = this.$selectSuppliersCheckbox.is(':checked');
        let rangesChecked = this.$selectSupplierRangesCheckbox.is(':checked');
        let deliveriesChecked = this.$selectDeliveryDaysCheckbox.is(':checked');
        if($item.attr('name') == 'selectSuppliers' && !suppliersChecked){
            this.$selectSupplierRangesCheckbox.prop('checked',false);
            this.$selectDeliveryDaysCheckbox.prop('checked',false);
        }

        if($item.attr('name') != 'selectSuppliers' && !suppliersChecked && $item.is(':checked')){
            this.$selectSuppliersCheckbox.prop('checked',true);
        }
    }

    onDOMReady(){
        super.onDOMReady();
        this.$targetSelect.select2();
    }

    getFields(){
        let fields = super.getFields();
        return fields;
    }
    
    getVariables(){
        let variables = {};

        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };

        return variables;
    }


}

module.exports = RangeAndDeliveryDayForm;

